export const MAX_ROBOT_USERS = 25